import Vue from 'vue'
import App from './App.vue'
import router from './router'
import request from './utils/request'
import VueMeta from 'vue-meta'

Vue.config.productionTip = false
Vue.config.ignoredElements = ['k', 'c', 'f', 'g','e', 'b', 'font', 'left', 'right']

// 全局挂载请求工具
Vue.prototype.$request = request

// 使用 vue-meta 管理 SEO
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

new Vue({
  router,
  render: h => h(App),
  mounted() {
    // 延迟初始化 scrollClass 动画插件，确保 Vue 渲染完成
    setTimeout(() => {
      if (typeof jQuery !== 'undefined' && jQuery.fn.scrollClass) {
        // 先移除所有 action 类，让 scrollClass 重新检测
        jQuery('.target.action').removeClass('action')
        // 重新初始化 scrollClass
        jQuery('.target').scrollClass()
      }
    }, 1000)
    
    // 初始化网页翻译插件
    setTimeout(() => {
      if (typeof translate !== 'undefined') {
        translate.setUseVersion2()
        translate.selectLanguageTag.show = false
        translate.execute()
      }
    }, 500)

    // 触发预渲染完成事件
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
